import React, { useState } from 'react';

interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 code, e.g. us, ca, in */
  isoCode: string;
  /** Display width in px (height scales ~3:4). Default 18. */
  size?: number;
  alt?: string;
  style?: React.CSSProperties;
}

/**
 * Renders a country flag via flagcdn. Hides itself if the image fails to load.
 */
const CountryFlag: React.FC<CountryFlagProps> = ({
  isoCode,
  size = 18,
  alt,
  style,
}) => {
  const [failed, setFailed] = useState(false);
  const code = (isoCode || '').trim().toLowerCase();
  if (!code || failed) return null;

  const height = Math.round(size * 0.75);

  return (
    <img
      src={`https://flagcdn.com/w40/${code}.png`}
      alt={alt || ''}
      width={size}
      height={height}
      loading="lazy"
      onError={() => setFailed(true)}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        objectFit: 'cover',
        borderRadius: 2,
        flexShrink: 0,
        ...style,
      }}
    />
  );
};

export default CountryFlag;
